var render = function render(){var _vm=this,_c=_vm._self._c;return _c('img',{staticClass:"tw-w-full tw-h-full tw-object-fit",attrs:{"src":_vm.pictureUrl}})
}
var staticRenderFns = []

export { render, staticRenderFns }